import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import TopoSemMenu from '../../components/TopoSemMenu';
import Confirmar from './components/Confirmar';
import EscolherData from './components/EscolherData';
import EscolherPonto from './components/EscolherPonto';

class Agendamento extends React.Component {
  render() {
    return (
      <div>
        <TopoSemMenu/>

        <Switch>
          <Route exact path="/agendamento/escolher-dia" component={ () => <EscolherData reagendar={ false } /> } />
          <Route exact path="/agendamento/escolher-dia/reagendar" component={ () => <EscolherData reagendar={ true } /> } />
          <Route exact path="/agendamento/escolher-ponto" component={ () => <EscolherPonto reagendar={ false } /> } />
          <Route exact path="/agendamento/escolher-ponto/reagendar" component={ () => <EscolherPonto reagendar={ true } /> } />
          <Route path="/agendamento/confirmar" component={Confirmar} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Agendamento);
